import { variationLines, type VariationSnapshot } from '../lib/menuVariation'

interface VariationLineProps {
  item: { variations?: VariationSnapshot[] | null; variationText?: string }
  /** 店側の注文一覧用。**作り分けに直結する**ので、客側の薄い補足と違って濃く出す。 */
  emphasis?: boolean
  /**
   * #2156 店員だけが読む画面か（レジ販売・レジ会計・注文管理）。true なら**日本語だけ**。
   *
   * 客の画面で日本語を併記するのは「客がスマホを店員に見せたとき双方が読める」ため
   * （`lib/itemName.ts` の `itemNameLines`）。**店側の画面は店員しか見ない**ので、
   * 客の言語を足す理由が無い（商品名も日本語だけで出している）。
   */
  staff?: boolean
}

/**
 * #2031 明細の品名の下に出す、選んだバリエーション（`味: たれ`）。
 *
 * カート・支払い・注文履歴・店側の注文一覧で同じものを出すために 1 つにしてある。
 * 選んでいない品では何も出さないので、バリエーションを使わない店の画面は変わらない。
 *
 * #2156 **客の言語が主・日本語が従で、両方出す**（商品名と同じ形）。日本語を残すのが
 * 肝で、客が画面を店員に見せたときに双方が読める。日本語で注文したとき・訳が無いときは
 * 1 行のままなので、使っていない店の画面は変わらない。
 */
export default function VariationLine({ item, emphasis = false, staff = false }: VariationLineProps) {
  const lines = variationLines(item)
  // 店側は日本語だけ。`secondary` が日本語の選択肢なので、あればそれを 1 行で出す
  const primary = staff ? (lines.secondary ?? lines.primary) : lines.primary
  const secondary = staff ? undefined : lines.secondary
  if (!primary) return null
  return (
    <>
      <span
        className={emphasis
          ? 'block font-jp text-xs font-semibold text-yokoso-red'
          : 'block font-jp text-[11px] text-text-tertiary'}
      >
        {primary}
      </span>
      {secondary && (
        <span
          className={emphasis
            ? 'block font-jp text-[11px] text-yokoso-red/70'
            : 'block font-jp text-[10px] text-text-disabled'}
        >
          {secondary}
        </span>
      )}
    </>
  )
}
